import { render, staticRenderFns } from "./FranchiseSizeBox.vue?vue&type=template&id=704fc708&"
import script from "./FranchiseSizeBox.vue?vue&type=script&lang=js&"
export * from "./FranchiseSizeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports